import { StatsTracker } from "./statsTracker";

export class GameStats {
	tracker: StatsTracker;
	startedAt: string;
	levelsVisited: number = 0;
	turnsPerLevel: Map<number, number> = new Map();
	causeOfDeath: { sourceKey: string; damageType: string } | null = null;

	constructor() {
		this.tracker = new StatsTracker();
		this.startedAt = new Date().toISOString();
	}

	// Game-level recording methods
	recordLevelVisited(): void {
		this.levelsVisited++;
	}

	getTotalTurnsElapsed(): number {
		let total = 0;
		for (const turns of this.turnsPerLevel.values()) total += turns;
		return total;
	}

	recordCauseOfDeath(sourceKey: string, damageType: string): void {
		this.causeOfDeath = { sourceKey, damageType };
	}

	updateTurnsForLevel(levelNumber: number, boardTurnCount: number): void {
		this.turnsPerLevel.set(levelNumber, boardTurnCount);
	}

	// Derived stat getters
	getMostUsedWeapon(): string | null {
		return this.getMaxKey(this.tracker.shotsFiredByWeapon);
	}

	getMostLethalWeapon(): string | null {
		return this.getMaxKey(this.tracker.killsByWeaponKey);
	}

	getFavoriteLevelNumber(): number | null {
		if (this.turnsPerLevel.size === 0) return null;
		let maxTurns = -1;
		let maxLevel: number | null = null;
		for (const [level, turns] of this.turnsPerLevel) {
			if (turns > maxTurns) {
				maxTurns = turns;
				maxLevel = level;
			}
		}
		return maxLevel;
	}

	private getMaxKey(map: Map<string, number>): string | null {
		if (map.size === 0) return null;
		let maxVal = -1;
		let maxKey: string | null = null;
		for (const [key, val] of map) {
			if (val > maxVal) {
				maxVal = val;
				maxKey = key;
			}
		}
		return maxKey;
	}

	serialize(): Record<string, unknown> {
		return {
			tracker: this.tracker.serialize(),
			startedAt: this.startedAt,
			levelsVisited: this.levelsVisited,
			turnsPerLevel: Object.fromEntries(this.turnsPerLevel),
			causeOfDeath: this.causeOfDeath,
		};
	}

	static deserialize(data: any): GameStats {
		const stats = new GameStats();
		stats.tracker = StatsTracker.deserialize(data.tracker);
		stats.startedAt = data.startedAt;
		stats.levelsVisited = data.levelsVisited ?? 0;
		stats.turnsPerLevel = new Map(
			Object.entries(data.turnsPerLevel ?? {}).map(([k, v]) => [Number(k), v as number]),
		);
		stats.causeOfDeath = data.causeOfDeath ?? null;
		return stats;
	}
}
